export default {
  pause: {
    name: 'Перерыв'
  },
  ready: {
    name: 'В очереди'
  },
  review: {
    name: 'Собирают'
  },
  delivery: {
    name: 'На маршруте'
  },
  ontheway: {
    name: 'Возвращаются'
  },
  close: {
    name: 'Закрыть'
  },
  open: {
    name: 'Открыть'
  },
  not_open: {
    name: 'Не открыта'
  },
  gain: {
    name: 'На усилении'
  },
  wait_open: {
    name: 'Ждёт открытия'
  },
  wait_close: {
    name: 'Ждёт закрытия'
  },
  rest_couriers: {
    name: 'Остальные'
  }
}